module.exports = __webpack_public_path__ + "static/img/3.34a880f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/sp/3.png
// module id = a+bO
// module chunks = 0